const childRoutes = (prop) => [
  {
    path: 'seizer-list',
    name: prop + '.seizer_list',
    meta: { auth: true },
    component: () => import('../pages/seizer-list/List.vue')
  },
  {
    path: 'tagging-social-worker',
    name: prop + '.tagging_social_worker',
    meta: { auth: true },
    component: () => import('../pages/tagging-social-worker/List.vue')
  },
  {
    path: 'case-file-management',
    name: prop + '.case_file_management',
    meta: { auth: true },
    component: () => import('../pages/case-file-management/List.vue')
  },
  {
    path: 'court-calendar',
    name: prop + '.court_calendar',
    meta: { auth: true },
    component: () => import('../pages/court-calendar/List.vue')
  },
  {
    path: 'court-attendance',
    name: prop + '.court_attendance',
    meta: { auth: true },
    component: () => import('../pages/court-attendance/List.vue')
  },
  {
    path: 'release-order',
    name: prop + '.release_order',
    meta: { auth: true },
    component: () => import('../pages/release-order/List.vue')
  },
  {
    path: 'e-notification',
    name: prop + '.e_notification',
    meta: { auth: true },
    component: () => import('../pages/e-notification/List.vue')
  },
  {
    path: 'certificate',
    name: prop + '.certificate',
    meta: { auth: true },
    component: () => import('../pages/release-order/certificateView.vue')
  }
]
const routes = [{
  path: '/child-service/legal-institute-management',
  name: 'child_service.legal_institute_management',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.legal_institute_management')
}]

export default routes
